import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationsStagesPlanWorks(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].GET_REGULATIONS_STAGES_PLAN_WORKS,
		options
	)
}
function _getRegulationsStagesPlanWorkPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS]
			.GET_REGULATIONS_STAGES_PLAN_WORK_PREVIEW,
		options
	)
}
function _getRegulationsStagesPlanWorkPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS]
			.GET_REGULATIONS_STAGES_PLAN_WORK_POPUP,
		options
	)
}
function _getRegulationsStagesPlanWorkExtendedPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS]
			.GET_REGULATIONS_STAGES_PLAN_WORK_EXTENDED_POPUP,
		options
	)
}

function _createRegulationsStagesPlanWork(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].CREATE_REGULATIONS_STAGES_PLAN_WORK,
		options
	)
}

function _getRegulationsStagesPlanWork(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].GET_REGULATIONS_STAGES_PLAN_WORK,
		options
	)
}

function _getRegulationsStagesPlanWorkDoneWorks(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS]
			.GET_REGULATIONS_STAGES_PLAN_WORK_DONE_WORKS,
		options
	)
}

function _patchRegulationsStagesPlanWork(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].PATCH_REGULATIONS_STAGES_PLAN_WORK,
		options
	)
}

function _putRegulationsStagesPlanWork(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].PUT_REGULATIONS_STAGES_PLAN_WORK,
		options
	)
}

function _deleteRegulationsStagesPlanWork(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].DELETE_REGULATIONS_STAGES_PLAN_WORK,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].GET_REGULATIONS_STAGES_PLAN_WORKS]:
		_getRegulationsStagesPlanWorks,

	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS]
		.GET_REGULATIONS_STAGES_PLAN_WORK_PREVIEW]: _getRegulationsStagesPlanWorkPreview,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS]
		.GET_REGULATIONS_STAGES_PLAN_WORK_POPUP]: _getRegulationsStagesPlanWorkPopup,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS]
		.GET_REGULATIONS_STAGES_PLAN_WORK_EXTENDED_POPUP]: _getRegulationsStagesPlanWorkExtendedPopup,

	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].CREATE_REGULATIONS_STAGES_PLAN_WORK]:
		_createRegulationsStagesPlanWork,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].GET_REGULATIONS_STAGES_PLAN_WORK]:
		_getRegulationsStagesPlanWork,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].PATCH_REGULATIONS_STAGES_PLAN_WORK]:
		_patchRegulationsStagesPlanWork,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].PUT_REGULATIONS_STAGES_PLAN_WORK]:
		_putRegulationsStagesPlanWork,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].DELETE_REGULATIONS_STAGES_PLAN_WORK]:
		_deleteRegulationsStagesPlanWork,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS]
		.GET_REGULATIONS_STAGES_PLAN_WORK_DONE_WORKS]: _getRegulationsStagesPlanWorkDoneWorks,
}
